import React, { useRef } from "react";
import { OTPContainer, OTPInputs, OTPInput, OTPHint } from "../styles";

const Otp6 = ({ label, value, onChange }) => {
  const OTP_LENGTH = 4;
  const refs = useRef([]);
  const digits = Array.from({ length: OTP_LENGTH }, (_, i) => (value[i] ? value[i] : ""));
  const clean = (s) => s.replace(/[^0-9]/g, "");

  const setAt = (i, ch) => {
    const one = clean(ch).slice(-1);
    const arr = clean(value)
      .padEnd(OTP_LENGTH, " ")
      .slice(0, OTP_LENGTH)
      .split("");
    arr[i] = one || " ";
    onChange(arr.join("").split(" ").join(""));
  };

  const focus = (i) => {
    const el = refs.current[i];
    if (el) el.focus();
  };

  const onPaste = (e) => {
    const txt = clean(e.clipboardData.getData("text") || "").slice(0, OTP_LENGTH);
    if (!txt) return;
    e.preventDefault();
    onChange(txt);
    focus(Math.min(OTP_LENGTH - 1, Math.max(0, txt.length - 1)));
  };

  return (
    <OTPContainer>
      <div style={{ fontSize: 12, color: "rgba(210,235,245,.8)", fontWeight: 800 }}>
        {label}
      </div>
      <OTPInputs onPaste={onPaste}>
        {digits.map((d, i) => (
          <OTPInput
            key={i}
            ref={(el) => (refs.current[i] = el)}
            inputMode="numeric"
            autoComplete="one-time-code"
            value={d}
            onChange={(e) => {
              const v = clean(e.target.value);
              setAt(i, v);
              if (v && i < OTP_LENGTH - 1) focus(i + 1);
            }}
            onKeyDown={(e) => {
              if (e.key === "Backspace" && !digits[i] && i > 0) focus(i - 1);
              if (e.key === "ArrowLeft" && i > 0) focus(i - 1);
              if (e.key === "ArrowRight" && i < OTP_LENGTH - 1) focus(i + 1);
            }}
          />
        ))}
      </OTPInputs>
      <OTPHint>Tip: paste a {OTP_LENGTH}-digit code anywhere.</OTPHint>
    </OTPContainer>
  );
};

export default Otp6;
